import { Magic } from "magic-sdk";


import { OAuthExtension } from '@magic-ext/oauth2';
import { REACT_APP_ENV } from "../common/globalImports";
import { ethers } from 'ethers';
import { polygon, polygonAmoy, sepolia } from "viem/chains";


import { toNexusAccount, createSmartAccountClient, createBicoPaymasterClient, encodeFunctionData, parseUnits, 
  createMeeClient,
  toMultichainNexusAccount } from "@biconomy/abstractjs";
import { http } from "viem";
// import gasless from "./biconomy";


// export const network = {
//   rpcUrl: 'https://eth-sepolia.public.blastapi.io',
//   chainId: 11155111
// }

export const network ={
  rpcUrl: 'https://polygon-rpc.com/',
  chainId: 137,
};

// export const network = process.env.REACT_APP_ENV !== "prod"
//   ? {
//       rpcUrl: 'https://rpc-amoy.polygon.technology/',
//       chainId: 80002,
//     }
//   : {
//       rpcUrl: 'https://polygon-rpc.com/',
//       chainId: 137,
//     };

// export const network = {
//   rpcUrl: 'https://polygon-rpc.com/',
//   chainId: 137,
// };

// polygon 
// export const contractAddress = process.env.REACT_APP_ENV !== "prod" ? "0xc7e9cdd039614dd17d4db59f91d7c258d0adc9a5" : "0xc2132d05d31c914a87c6611c10748aeb04b58e8f";

// polygon mainnet
export const contractAddress = "0xc2132d05d31c914a87c6611c10748aeb04b58e8f";

// sepolia testnet
// export const contractAddress = "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238";
// export const contractAddress = "0xc2132d05d31c914a87c6611c10748aeb04b58e8f";

export const centralAddress = process.env.REACT_APP_ENV !== "prod" ? "0xA1F08E67956D801dC32A92eBf71f8D0c93CB3e36" : "0x54154f96FDE8EC07fe77b19b69Ec6878E6Bc6eCa";
// export const centralAddress = "0x54154f96FDE8EC07fe77b19b69Ec6878E6Bc6eCa";
console.log("DETAILS",contractAddress, centralAddress, network, "NETWORK DETAIL");
const m = new Magic(process.env.REACT_APP_ENV !== "prod" ? "pk_live_91C5C14C9943D1A2" : "pk_live_91C5C14C9943D1A2", {
    extensions: [new OAuthExtension()],
    network
    // testMode: process.env.REACT_APP_ENV !== "prod",
});



export const provider = new ethers.BrowserProvider(m.rpcProvider);

export const getFees = async () => {
  const provider = new ethers.JsonRpcProvider(network.rpcUrl);

  const feeData = await provider.getFeeData();

  const maxPriorityFeePerGas = feeData.maxPriorityFeePerGas || ethers.parseUnits("2", "gwei"); // Set a default if not available
  const maxFeePerGas = feeData.maxFeePerGas || maxPriorityFeePerGas * 2n; // Typically, maxFeePerGas > maxPriorityFeePerGas

  return {
    maxPriorityFeePerGas,
    maxFeePerGas,
  };
}

window.magic = m;
export const magic = m;

const CHAIN_MAPPING = {
  137: polygon,      // Polygon Mainnet
  80001: polygonAmoy, // Polygon Mumbai
  11155111: sepolia   // Sepolia
};

const PAYMASTER_URLS = {
  137: 'https://paymaster.biconomy.io/api/v2/137/iJ3rt1Al4.867f0689-1416-40d7-aeed-76b252b5317c', // Polygon Mainnet
  80001: 'https://paymaster.biconomy.io/api/v2/80001/YOUR_MUMBAI_KEY', // Mumbai Testnet
  11155111: 'https://paymaster.biconomy.io/api/v2/11155111/6WNlM_6rC.10853fea-a4d8-4652-b807-c665e399f8a6' // Sepolia
};

export const createSmartAccountOwner = async ({ chainId, rpcUrl }) => {
  try {
    const chain = CHAIN_MAPPING[chainId] || polygon; // default to polygon if chain not found

    const smartAccountOwner = await toNexusAccount({
      signer: m.rpcProvider,
      chain,
      transport: http(rpcUrl),
    });
    
    return smartAccountOwner;
  } catch (error) {
    console.error("Error creating smart account owner:", error);
    throw error;
  }
};

export const getScwAddress = async ({chainId, rpcUrl}) => {
  const smartAccountOwner = await createSmartAccountOwner({chainId, rpcUrl});
  const address = await smartAccountOwner.getAddress();
  return address;
}

export const createNexusClient = async ({ smartAccountOwner, bundlerUrl, chainId }) => {
  try {
    const paymasterUrl = PAYMASTER_URLS[chainId];
    if (!paymasterUrl) {
      throw new Error(`No paymaster URL configured for chain ID ${chainId}`);
    }

    const chain = CHAIN_MAPPING[chainId] || polygon; // default to polygon if chain not found

    const nexusClient = createSmartAccountClient({
      chain,
      account: smartAccountOwner,
      transport: http(bundlerUrl),
      paymaster: createBicoPaymasterClient({ paymasterUrl }),
    });

    return nexusClient;
  } catch (error) {
    console.error("Error creating nexus client:", error);
    throw error;
  }
};

export const getSmartAccountAddress = async (smartAccountOwner) => {
  try {
    if (!smartAccountOwner) {
      throw new Error("Smart account owner is required");
    }
    return smartAccountOwner.address;
  } catch (error) {
    console.error("Error getting smart account address:", error);
    throw error;
  }
};

export const transferUSDT = async (toAddress, amount) => {
  try {
    const provider = m.rpcProvider;
    if (!provider) {
      throw new Error("Magic provider not available. Ensure user is logged in.");
    }

    // Create smart account owner
    const smartAccountOwner = await createSmartAccountOwner({
      signer: provider,
      chainId: network.chainId,
      rpcUrl: network.rpcUrl
    });

    // Create nexus client
    // const bundlerUrl = 'https://bundler.biconomy.io/api/v3/137/c95c6aaa-1c40-414b-b8c9-b98247d8344f';
    const bundlerUrl = 'https://bundler.biconomy.io/api/v3/137/bundler_3ZRvztcCjRRiS1GcnQbnaY7J';
    const nexusClient = await createNexusClient({
      smartAccountOwner,
      bundlerUrl,
      chainId: network.chainId
    });

  //   const nexusClient = await newCreateSmartAccountClient({
  //     signer: provider,
  //     chain: polygon,
  //     transport: http(),
  //     bundlerTransport: http(bundlerUrl),
  //     paymaster: createBicoPaymasterClient({paymasterUrl: PAYMASTER_URLS[137]})
  // }); 


    // Encode USDT transfer
    const amountInWei = ethers.parseUnits(amount, 6).toString();
    const data = new ethers.Interface([
      "function transfer(address to, uint256 amount) returns (bool)"
    ]).encodeFunctionData("transfer", [toAddress, amountInWei]);

    // // Send transaction
    // let nonce = await smartAccountOwner.getNonce();
    const hash = await nexusClient.sendUserOperation({
      calls: [{ to: contractAddress, value: 0n, data }],
      // nonce
    });

    


    // console.log(hash, "HASH");

    // Wait for receipt
    const receipt = await nexusClient.waitForUserOperationReceipt({ hash });
    return {
      hash,
      receipt,
    };


  //   const hash = await nexusClient.sendTransaction({ calls: [{ to: contractAddress, value: 0n, data }] }); 
  // console.log("Transaction hash: ", hash) 
  // const receipt = await nexusClient.waitForTransactionReceipt({ hash });
return {
      hash,
      receipt,
    }
  } catch (error) {
    console.error("USDT Transfer Error:", error);
    throw error;
  }
};